import { render, staticRenderFns } from "./workflow_page.vue?vue&type=template&id=097a9c85&scoped=true&"
import script from "./workflow_page.vue?vue&type=script&lang=js&"
export * from "./workflow_page.vue?vue&type=script&lang=js&"
import style0 from "./workflow_page.vue?vue&type=style&index=0&id=097a9c85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a9c85",
  null
  
)

export default component.exports